import React from "react";
import {
    DataGrid,
    HeaderFilter,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager,
    Lookup,
    Format,
    FormItem,
    Sorting,
    Button as GridButton,
} from "devextreme-react/data-grid";
import Form, { SimpleItem, Label, ButtonItem, EmptyItem } from "devextreme-react/form";
import { Button } from "devextreme-react";
import uiInfo from "../ui-info";
import PaginaToolbar from "../components/PaginaToolbar";
import { criarAliquotaIPTUDs, criarNumeroComplementoConferencia, opcoesFatoresDs, criarLogradouroConferencia, criarLogradouroDs } from "../DataSources";
import UserInfo from "../UserInfo";
import react from "react";
import api from "../api-axios";
import { errorOnDev } from "react-pdf/dist/umd/shared/utils";
import { LoadIndicator } from "devextreme-react/load-indicator";

export default class ConferenciaLogradouro extends React.Component {
    constructor() {
        super();
        this.dataGrid = react.createRef();
        this.dataSource = criarLogradouroConferencia();
        this.logradouroDataSource = criarLogradouroDs();
        this.initNewRow = this.initNewRow.bind(this);
        this.naturezasDataSource = [
            { id: "T", descricao: "Territorial" },
            { id: "E", descricao: "Edificado" }
        ];
        this.state = {
            _uiMsgCarregamento: "",
            filtro: {
                distrito: 1,
                setor: 99,
            }
        };
        this.carregar = this.carregar.bind(this);
        this.gerarPlanta = this.gerarPlanta.bind(this);
        this.aplicar = this.aplicar.bind(this);
    }

    componentDidMount() {
        this.carregar();

    }
    carregar() {

        try {
            console.log("carregar");
            console.log(this.state);
            const novoFiltro = [];
            novoFiltro.push(["finalizado", "=", false])

            if (this.state.filtro.distrito && this.state.filtro.distrito != 0) {
                novoFiltro.push(["distrito", "=", this.state.filtro.distrito]);
            }

            if (this.state.filtro.setor && this.state.filtro.setor != 0) {
                novoFiltro.push(["setor", "=", this.state.filtro.setor]);
            }

            this.dataGrid.instance.filter(novoFiltro);
            this.dataGrid.instance.refresh();
        }
        catch (error) {
            console.log("Erro", error);
        }


    }

    async gerarPlanta() {


        const prefeituraId = UserInfo.getPrefeitura();
        const distrito = this.state.filtro.distrito??0;
        const setor = this.state.filtro.setor??0;


        try {

            this.setState({ _uiMsgCarregamento: "Gerando Planta..." });
            await api.post(`conferencia_logradouros/gerar_planta/${prefeituraId}/${distrito}/${setor}`);
            this.carregar();
        }
        catch (error) {
            console.log(error);
        }
        finally {
            this.setState({ _uiMsgCarregamento: "" });

        }
    }

    async aplicar() {
        const prefeituraId = UserInfo.getPrefeitura();

        try {

            this.setState({ _uiMsgCarregamento: "Aplicando Planta..." });

            const filtro = this.state.filtro;
            const distrito = filtro.distrito ?? 0;
            const setor = filtro.setor ?? 0;

            await api.post(`conferencia_logradouros/aplicar/${prefeituraId}/${distrito}/${setor}`);

        }
        catch (error) {
            console.log(error);
        }
        finally {
            this.setState({ _uiMsgCarregamento: "" });
            this.carregar();
        }
    }


    render() {

        if (this.state._uiMsgCarregamento) {
            return (
                <div className={"content-block dx-card responsive-paddings"}>
                    <div
                        style={{
                            display: "flex",
                            marginTop: "25px",
                            justifyContent: "center",
                            alignContent: "center",
                            justifyItems: "center",
                            alignItems: "center",
                        }}
                    >
                        <LoadIndicator width={60} height={60} />
                        <div style={{ marginLeft: 10 }}>{this.state._uiMsgCarregamento}</div>
                    </div>
                </div>
            );
        }

        return (

            <div className={'content-block dx-card responsive-paddings'}>
                <form onSubmit={this.filtrar}>
                    <Form id="frmPesquisa" formData={this.state.filtro} colCount={5}>
                        <SimpleItem
                            dataField="distrito"
                            editorType={"dxNumberBox"}
                            colSpan={1}
                            editorOptions={{ step: 0 }}
                        >
                            <Label text="Distrito" />
                        </SimpleItem>
                        <SimpleItem
                            dataField="setor"
                            editorType={"dxNumberBox"}
                            colSpan={1}
                            editorOptions={{ step: 0 }}
                        >
                            <Label text="Setor" />
                        </SimpleItem>
                        <ButtonItem buttonOptions={{ text: "Carregar", type: "success", width: "100%", onClick: this.carregar }} />
                        <ButtonItem buttonOptions={{ text: "Gerar Planta", type: "default", width: "100%", onClick: this.gerarPlanta }} />
                        <ButtonItem buttonOptions={{ text: "Aplicar", type: "default", width: "100%", onClick: this.aplicar }} />
                    </Form>
                </form>
                <br /> <br />
                <PaginaToolbar titulo="CONFERÊNCIA LOGRADOUROS">
                    <DataGrid
                        dataSource={this.dataSource}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        columnAutoWidth={true}
                        onInitNewRow={this.initNewRow}
                        keyExpr={"id"}
                        ref={(e) => this.dataGrid = e}>


                        <Editing allowUpdating={true} allowEditing={true} useIcons={true} allowDeleting={true} />

                        <Column
                            type="buttons"
                            fixed={true}
                            fixedPosition={"right"}
                            buttons={[
                                "edit",
                                "delete"
                            ]}
                        />

                        <Column dataField={"id"} visible={false}>
                            <FormItem visible={false}></FormItem>
                        </Column>

                        <Column dataField={'status'} caption={"Status"} allowEditing={false} width={120} alignment={"center"} />

                        <Column dataField={'distrito'} caption={"Dis"} width={70} alignment={"center"} sortIndex={0} sortOrder={"asc"} allowEditing={false} />
                        <Column dataField={'setor'} caption={"Set"} width={70} alignment={"center"} sortIndex={1} sortOrder={"asc"} allowEditing={false} />
                        <Column dataField={'quadra'} caption={"Qda"} width={90} alignment={"center"} sortIndex={2} sortOrder={"asc"} allowEditing={false} />
                        <Column dataField={'logradouroId'} caption={"Logradouro"} sortIndex={2} sortOrder={"asc"} allowEditing={false}>
                            <Lookup dataSource={this.logradouroDataSource} key={"id"} valueExpr={"id"} displayExpr={"nomeCompleto"} />
                        </Column>
                        <Column dataField={'novoLogradouroId'} caption={"Novo Logradouro"} sortIndex={2} sortOrder={"asc"}>
                            <Lookup dataSource={this.logradouroDataSource} key={"id"} valueExpr={"id"} displayExpr={"nomeCompleto"} allowClearing={true} />
                        </Column>




                        <Column dataField={'msgErro'} caption={"Erro"} visible={false} />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    initNewRow(e) {
        e.data.prefeituraId = UserInfo.getPrefeitura();
        e.data.distrito = this.state.filtro.distrito;
        e.data.setor = this.state.filtro.setor;
        e.data.quadra = this.state.filtro.quadra;
        e.data.status = "PENDENTE";
        console.log(e);
    }
}